import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "cms-msg-header" }
const _hoisted_3 = { class: "pull-right" }
const _hoisted_4 = { class: "cms-msg-body" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "cms-msg-content"
}
const _hoisted_7 = { class: "cms-msg-ctrl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_drag = _resolveDirective("drag")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "cms-msg",
      id: _ctx.id,
      ref: "main"
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "close cms-modal-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel($event)))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "material-icons" }, "close", -1)
          ]))
        ])
      ])), [
        [_directive_drag, {
          notUse: true,
          targetIdClass: '.cms-msg',
          moveX: true,
          moveY: true,
          cursor: false,
        }]
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.safe)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cms-msg-content",
              innerHTML: _ctx.message
            }, null, 8, _hoisted_5))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.message), 1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.cancelButton)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "javascript:void(0);",
              class: "btn-std-m btn-std-icon btn-std-secondary",
              "data-dismiss": "modal",
              "aria-hidden": "true",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel($event)))
            }, _toDisplayString(_ctx.cancelName), 1))
          : _createCommentVNode("", true),
        (_ctx.secondaryButton)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: "javascript:void(0);",
              class: "btn-std-m btn-std-icon btn-std-negative",
              "data-dismiss": "modal",
              "aria-hidden": "true",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.secondary($event)))
            }, _toDisplayString(_ctx.secondaryName), 1))
          : _createCommentVNode("", true),
        (_ctx.okButtonHide)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: "javascript:void(0);",
              class: _normalizeClass(["btn-std-m btn-std-icon btn-std-cta", _ctx.okClass]),
              "data-dismiss": "modal",
              "aria-hidden": "true",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ok($event)))
            }, _toDisplayString(_ctx.okName), 3))
          : _createCommentVNode("", true)
      ])
    ], 8, _hoisted_1)
  ]))
}